import * as React from 'react'
import { ReactComponent as DefaultLogo } from '../../assets/images/svg_icons/label.svg'

function SvgComponent() {
  return <DefaultLogo />
}

export default SvgComponent
